
export default {
    LOGIN: {
        TITLE: 'Login',
        MSG: 'Accès à votre portefeuille.',
        EMAIL: 'ID',
        PASSWORD: 'Mot de passe',
        LOGIN: 'Login',
        SIGN_UP: 'S\'inscrire',
        FORGOT_PASSWORD: 'Mot de passe oublié?',
        CONFIRM_PASSWORD: 'Confirmez le mot de passe',
        CREATE_ACCOUNT: 'Créer un compte',
        ALREADY_ACCOUNT_LOGIN: 'Vous avez déjà un compte? Login',
        REMEMBER_ME: 'Souviens-toi de moi',
    },
    CREDENTIALS: {
        TITLE: 'Mes informations d\'identification',
        SEARCH: 'Chercher...'
    },
    RECEIVE_CREDENTIALS: {
        CONFIRM_TITLE: 'Demande de connexion',
        CONFIRM_CONNECTION_WITH: 'Confirmer la connexion avec',
        CONFIRM: 'Confirmer',
        REJECT: 'Rejeter',
        RECEIVED_CREDENTIALS_TITLE: 'Reçu des informations d\'identification',
        RECEIVED_CREDENTIALS_SUBTITLE: 'Cliquez sur "Accepter" pour recevoir vos identifiants dans votre portefeuille',
        ACCEPT: 'J\'accepte'
    },
    BACK: 'Retour',
    MENU: {
        CREDENTIALS: 'Credentials',
        CONNECTIONS: 'Connexions',
        SETTINGS: 'Réglages',
        LOGOUT: 'Se déconnecter'
    },
    CREDENTIAL: {
        HASH:'Hash',
        ID: 'Credential Id',
        TITLE: 'Titre',
        ISSUER: 'Émetteur',
        STATUS: 'Statut',
        ISSUED_ON: 'Publié le',
        EXPIRE: 'Expirer',
        VALID_FROM: 'Valide à partir de',
        FIRST_NAME: 'Prénoms',
        GIVEN_NAME: 'Prénoms',
        LAST_NAME: 'Nom',
        FAMILY_NAME: 'Nom',
        GENDER: 'Sexe',
        DATE_OF_BIRTH: 'Date de naissance',
        ADDRESS: 'Adresse',
        STREET_ADDRESS: 'Adresse de la rue',
        POSTAL_CODE: 'Code postal',
        LOCALITY: 'Localité',
        COUNTRY_NAME: 'Nom du pays',
        FAMILY_STATUS: 'Situation de familie',
        IDENTIFICATION_NUMBER: 'N. d\'identification',
        DID: 'DID',
        NAME_AND_FAMILY_NAME_AT_BIRTH: 'Nom et nom de famille à la naissance',
        NATIONALITY: 'Nationalité',
        PLACE_OF_BIRTH: 'Lieu de naissance',
        PLACE_OF_BIRTH_COUNTRY: 'de campagne (lieu de naissance)',
        DATE_OF_BIRTH_LOCALITY: 'Localité (lieu de naissance)',
        PERSONAL_IDENTIFIER: 'Identifiant personnel',
        VACCINE_OR_PROFYLAXIS: 'Vaccin ou prophylaxie',
        VACCINE_MEDICINAL_PRODUCT: 'Médicament de vaccin',
        DOSE_NUMBER: 'Numéro de dose',
        DATE_OF_VACCINATION: 'Date de la vaccination',
        ADMINISTERING_CENTER: 'Centre d\'administration',
        COUNTRY_OF_VACCINATION: 'Pays de vaccination',
        PROGRAM_NAME: 'Nom du programme',
        DOMAIN: 'Domain',
        GRADING_SCHEMA: 'Schéma de notation',
        TYPE: {
            VerifiableId: 'Document d\'identification vérifiable',
            VerifiableDiploma: 'Diplôme universitaire vérifiable',
            VerifiableVaccinationCertificate: 'Certificat de vaccination vérifiable',
            ProofOfResidence: 'Certificat de Résidence',
            "gx:ParticipantCredential": "Gaia-X Identifiant du participant",
            VerifiableAttestation: "Verifiable attestation",
            EuropeanBankIdentity: "Identité bancaire européenne",
            OpenBadgeCredential: "Open Badge V3",
            Europass: "Europass"
        },
        REGISTRATION_NUMBER: 'Numéro d\'entreprise',
        LEGALLY_BINDING_NAME: 'Nom de l\'entreprise ',
        JURISDICTION: 'Pays du siège ',
        COUNTRY: 'Pays légal',
        LEI_CODE: 'LEI',
        ETH_ADDRESS: 'ETH Address',
        PARENT_ORGANIZATION: 'Organisation mère',
        SUB_ORGANIZATION: 'Sous-organisation',
        LEARNING_ACHIEVEMENT: 'Learning achievement',
        ECTS_CREDIT_POINTS: 'ECTS credit points',
        DEFINITION: 'Definition',
        EQFL_LEVEL: 'EQFL level',
        NQFL_LEVEL: 'NQFL level',
        LOCATION: 'Location',
        STARTED_AT_TIME: 'Started at time',
        ENDED_AT_TIME: 'Ended at time',
        HOME_PAGE: 'Home page',
        ADDITIONAL_NOTE: 'Additional note',
        WORKLOAD: 'Workload',
        AWARDING_BODY: 'Awarding body',
        MAXIMUM_DURATION: 'Maximum duration',
        VOLUME_OF_LEARNING: 'Volume of learning',
        IS_PARTIAL_QUALIFICATION: 'Is Partial Qualification',
        LANGUAGE: 'Language',
        ALTERNATIVE_LABEL: 'Alternative label',
        SUPPLEMENTARY_DOCUMENT: 'Supplementary document',
        MODE: 'Mode',
        ISCEDF_CODE: 'ISCEDF code',
        IDENTIFIER: 'Identifier',
        ACHIEVED: 'Achieved',
        WAS_DERIVED_FROM: 'Was derived from',
        WAS_INFLUENCED_BY: 'Was influenced by',
        WAS_AWARDED_BY: 'Was awarded by',
        SPECIFIED_BY: 'Specified by',
        LEARNING_OUTCOME: 'Learning outcome',
        AWARDING_OPPORTUNITY: 'Awarding opportunity',
        LEARNING_ACTIVITY_TYPE: 'Learning activity type',
        DIRECTED_BY: 'Directed by',
        GRADE: 'Grade',
        AWARDING_DATE: 'Awarding date',
        AWARDING_LOCATION: 'Awarding location',
        DESCRIPTION: 'Description',
        ISSUED_DATE: 'Issued date',
        ENTITLEMENT_TYPE: 'Entitlement type',
        LIMIT_ORGANIZATION: 'Limit organization',
        LIMIT_JURISDICTION: 'Limit jurisdiction',
        SCHEME_ID: 'Scheme Id',
        VALUE: 'Value',
        ASSESSED_BY: 'Assessed by',
        TEACHES: 'Teaches',
        HAS_PART: 'Has part',
        ENTRY_REQUIREMENTS_NOTE: 'Entry requirements note',
        NAME: 'Name',
        LEARNING_OUTCOME_TYPE: 'Learning outcome type',
        REUSABILITY_LEVEL: 'Reusability level',
        RELATED_SKILL: 'Related skill',
        RELATED_ESCO_SKILL: 'Related ESCO skill',
        LEARNING_OPPORTUNITY_TYPE: 'Learning opportunity type',
        LEARNING_OUTCOME_DESCRIPTION: 'Learning outcome description',
        EDUCATION_SUBJECT: 'Education subject',
        CREDIT_POINTS: 'Credit points',
        EDUCATION_LEVEL: 'Education level',
        LEARNING_SETTING: 'Learning setting',
        TARGET_GROUP: 'Target group',
        LEARNING_ACTIVITY_SPECIFICATION: 'Learning activity specification',
        ASSESSMENT_SPECIFICATION: 'Assessment specification',
        ENTITLEMENT_SPECIFICATION: 'Entitlement specification',
        SPECIALIZATION_OF: 'Specialization of',
        EIDAS_LEGAL_IDENTIFIER: 'EIDAS legal identifier',
        REGISTRATION: 'Registration',
        PREFERRED_NAME: 'Preferred name',
    },
    CREDENTIAL_SUBJECT: {
        TYPE: "Credential Subject Type",
        ID: "Credential Subject ID",
    },
    ISSUER: {
        TYPE: "Issuer Type",
        ID: "Issuer ID",
        URL: "Issuer URL"
    },
    ACHIEVEMENT: {
        TYPE: "Achievement Type",
        URL: "Achievement Url",
        NAME: "Achievement Name",
        DESCRIPTION: "Achievement Description"
    },
    CRITERIA: {
        TYPE: "Criteria Type",
        NARRATIVE: "Criteria Narrative"
    },
    CREDENTIAL_SCHEMA:{
        ID: "Credntial Schema ID",
        TYPE: "Credential Schema Type"
    }
}
